import { render, staticRenderFns } from "./PrescriptiveAnalysis.vue?vue&type=template&id=32296f99&"
import script from "./PrescriptiveAnalysis.vue?vue&type=script&lang=js&"
export * from "./PrescriptiveAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32296f99')) {
      api.createRecord('32296f99', component.options)
    } else {
      api.reload('32296f99', component.options)
    }
    module.hot.accept("./PrescriptiveAnalysis.vue?vue&type=template&id=32296f99&", function () {
      api.rerender('32296f99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wla/PrescriptiveAnalysis.vue"
export default component.exports